import React from "react";
import {
  X,
  Linkedin,
  Pin,
  Instagram,
  Facebook,
  Rocket,
  Heart,
} from "lucide-react";

// Sosyal medya platformları için veriler
const socialLinks = [
  {
    name: "X (Twitter)",
    url: "https://x.com/mekanname",
    icon: <X size={24} />,
    color: "from-gray-700 to-gray-900", // X için koyu gradient
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/mek%C3%A2nname-ai-2a375a37a/",
    icon: <Linkedin size={24} />,
    color: "from-blue-700 to-blue-500", // LinkedIn mavisi
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/mekannameai/",
    icon: <Instagram size={24} />,
    color: "from-purple-500 via-pink-500 to-orange-500", // Instagram gradienti
  },
  {
    name: "Pinterest",
    url: "https://tr.pinterest.com/mekanname/",
    icon: <Pin size={24} />,
    color: "from-red-700 to-red-500", // Pinterest kırmızısı
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61579397969576",
    icon: <Facebook size={24} />,
    color: "from-blue-600 to-blue-400", // Facebook mavisi
  },
  {
    name: "Teknofest",
    url: "https://sosyal.teknofest.app/@mekanname",
    icon: <Rocket size={24} />,
    color: "from-teal-500 to-cyan-500", // Teknofest için teknolojik bir renk
  },
  {
    name: "Patreon",
    url: "https://www.patreon.com/c/Mekanname",
    icon: <Heart size={24} />,
    color: "from-yellow-500 to-red-500", // Patreon için destekleyici bir renk
  },
];

const SocialLinksPage = () => {
  return (
    // Ana konteyner, dark mode arka planı ve hizalama
    <div className="bg-gray-850 min-h-screen flex flex-col items-center justify-center p-4 font-sans antialiased text-white">
      {/* Başlık ve açıklama kartı */}
      <div className="bg-gray-800 rounded-3xl p-6 sm:p-10 shadow-xl border border-gray-800 w-full max-w-lg mx-auto text-center mb-8">
        <h1 className="text-3xl md:text-4xl font-extrabold text-white mb-2 leading-tight">
          Bize Katılın
        </h1>
        <p className="text-gray-400 text-lg">
          Mekânname'yi sosyal medyada takip ederek en son güncellemelerden haberdar olun.
        </p>
      </div>

      {/* Sosyal medya butonlarının listesi */}
      <div className="flex flex-col gap-4 w-full max-w-sm">
        {socialLinks.map((link) => (
          <a
            key={link.name}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`
              w-full py-4 rounded-xl text-lg font-bold
              bg-gradient-to-r ${link.color}
              transform transition-all duration-300
              shadow-lg flex items-center justify-center gap-4
              group hover:scale-105 hover:shadow-2xl hover:bg-opacity-80
            `}
          >
            {/* Butonun üzerine gelindiğinde rengi ve konumu değişen ikon ve metin */}
            <div className="flex items-center gap-4 transition-all duration-300 group-hover:translate-x-1">
              <span className="text-white group-hover:text-gray-200">{link.icon}</span>
              <span className="text-white group-hover:text-gray-200">{link.name}</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialLinksPage;
